import * as React from "react";

interface Props {
  submitText: string;
  closeModal: () => void;
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const CancelSubmitButtons = (props: Props) => {
  return (
    <div className="pull-right">
      <button
        className="btn btn-default"
        onClick={props.closeModal} >
        Cancel
      </button>
      <button
        className="btn btn-success"
        onClick={e => props.onSubmit(e)}>
        {props.submitText}
      </button>
    </div>
  )
}
